import './styles/Selector.css'
import './styles/SelectorAdmin.css'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import data_ubi from './ubicaciones'
import { useFetch } from '../hooks/useFetch'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from './generales/traduction'
const SelectorAdmin=({languaje,index,opGeneral,placeholder,txtOpGen,opt_de,titulo,data,loading,selectFunction,origen})=>{
    // console.log(data)
    
    const customStyles = {
        menuPortal: base => ({
            ...base,
            maxHeight: '50px',
            zIndex: 9999 // Ajusta el z-index según sea necesario
          }),
        // Estilos para el contenedor del react-select
        control: (provided, state) => ({
          ...provided,
          color:'#003757',
          borderColor: state.isFocused ? '#80bdff' : '#ccc',
          boxShadow: state.isFocused ? '0 0 0 1px #80bdff' : null,
          '&:hover': {
            borderColor: state.isFocused ? '#80bdff' : '#999',
          },
        }),
        // Estilos para las opciones en el menú desplegable
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? '#80bdff' : null,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#aa9c9c', // Color deseado para el placeholder
          }),
      };
    const opt_default=(opGeneral)?[{ dispId: 0, name: txtOpGen ,id:0}]:[]
    const data_aux=opt_default.concat(data)
//    console.log(data_aux)
    let cont_i=0;
    let opcion_default=0
    const options=loading?{filter:titulo, value: 0, label: 'cargando...' ,id:0}:data_aux.map(datas=>{
        // console.log(datas)
        if(opt_de==0){
            // console.log("es 0")
            opcion_default=0
        }else{
            // console.log(datas)
            if(datas.id==opt_de){
                // console.log(" el valor es" ,cont_i)
                opcion_default=cont_i
            }
        }
        
        cont_i++
        let op;
        switch(titulo){
            case 'Municipio': op={ filter:titulo,value: datas.groupid === undefined?0:datas.groupid , label: datas.name ,id:datas.id};
                                break;
            case 'Tecnología': op={ filter:titulo,value: datas.dispId=== undefined?0:datas.dispId, label: datas.name ,id:datas.id};
                                break; 
            case 'Marca': op={ filter:titulo,value: datas.brand_id=== undefined?0:datas.brand_id, label:(languaje==undefined)?datas.value:(lang[languaje][datas.value.toLowerCase()]==undefined?datas.value:capitalizeFirstLetter(lang[languaje][datas.value.toLowerCase()])),id:datas.id};
                                break;  
            case 'Modelo': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.value ,id:datas.id};
                                break;  
            case 'CIS': op={ filter:titulo,value: datas.element_id=== undefined?0:datas.element_id, label: datas.folio ,id:datas.element_id};
                                break; 
            case 'statusConf': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name ,id:datas.id};
                                break;           
            case 'CisTec': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.value ,id:datas.id};
                                break;     
            case 'Proxys': op={ filter:titulo,value: datas.proxyid=== undefined?0:datas.proxyid, label: datas.host ,id:datas.proxyid};
                                break; 
            case 'Estados': op={ filter:titulo,value: datas.id, label: datas.name ,id:datas.id};
                                break; 
            case 'Agencia': op={ filter:titulo,value: datas.exception_agency_id=== undefined?0:datas.exception_agency_id, label: datas.name ,id:datas.id};
                                break; 
            case 'Severity': op={ filter:titulo,value: datas.cassia_criticality_id=== undefined?0:datas.cassia_criticality_id, label: datas.name ,id:datas.id};
                                break; 
            case 'Marcas': op={ filter:titulo,value: datas.brand_id=== undefined?0:datas.brand_id, label: datas.name_brand ,id:datas.brand_id};
                                break;   
            case 'hostModel': op={ filter:titulo,value: datas.model_id=== undefined?0:datas.model_id, label: datas.name_model ,id:datas.model_id};
                                break;   
            case 'techDevices': op={ filter:titulo,value: datas.dispId=== undefined?0:datas.dispId, label: datas.name ,id:datas.dispId};
                                break;
            case 'proxy': op={ filter:titulo,value: datas.proxy_id=== undefined?0:datas.proxy_id, label: (datas.proxy_name==null && datas.proxy_ip==null)?'':(datas.proxy_name+"   ("+(datas.proxy_ip==null?'':datas.proxy_ip)+")") ,id:datas.proxy_id};
                                break;      
            case 'Grupos': op={ filter:titulo,value: datas.groupid=== undefined?0:datas.groupid, label: datas.group_name ,id:datas.groupid};
                                break;   
            case 'Modulos': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name ,id:datas.id};
                                break;
            case 'trigger': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name ,id:datas.id};//,isDisabled:!datas.disponible
                                break; 
            case 'period': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name ,id:datas.id};//,isDisabled:!datas.disponible
                                break;  
            case 'Metric': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.visible_name ,id:datas.id};//,isDisabled:!datas.disponible
                                break;  
            case 'Event': op={ filter:titulo,value: datas.event_id=== undefined?0:datas.event_id, label: datas.name	 ,id:datas.event_id};//,isDisabled:!datas.disponible
                                break;   
            case 'Host': op={ filter:titulo,value: datas.hostid=== undefined?0:datas.hostid, label: datas.host	 ,id:datas.hostid};//,isDisabled:!datas.disponible
                                break; 
            case 'Repeat': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.visual ,id:datas.id};
                                break;    
            case 'RepeatType': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.type ,id:datas.id};
                                break;    
            case 'Software': op={ filter:titulo,value: datas.softwarekey=== undefined?0:datas.softwarekey, label: datas.name ,id:datas.softwarekey};
                                break; 
            case 'SO': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.operating_system_name+" "+datas.operating_system_version ,id:datas.id};
                                break;
            case 'typeGroup': op={ filter:titulo,value: datas.value=== undefined?0:datas.value, label: datas.value,id:datas.value};
                                break; 
            case 'services_catalog': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.service_name,id:datas.id};
                                break;   
            case 'groups_catalog': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name,id:datas.id};
                                break;     
            case 'field_option': op={ filter:titulo,value: datas.value, label: datas.label,id:datas.value};    
             break; 
            case 'Metricas': op={ filter:titulo,value: datas.id, label: datas.metric,id:datas.id};    
             break; 
            case 'Triggers': op={ filter:titulo,value: datas.id, label: datas.metric_name==undefined?'':datas.name+' / '+datas.metric_name,id:datas.id};    
             break; 
            case 'event_wf': op={ filter:titulo,value: datas.event_id, label: datas.name,id:datas.event_id};    
             break; 
            case 'roles': op={ filter:titulo,value: datas.rol_id, label: datas.name,id:datas.rol_id};    
             break;                                                                              
            default:
                op={ value: '', label: '' };
                    break;                        
        }
        return op                           // <option key={datas.uuid}> {datas.name} </option>
})
// console.log(options[opcion_default])
// console.log(options[opcion_default].label)
//console.log(options)
//console.log(opt_de)
    
    
    
    const [value,setValue]=useState([])
    
    // //console.log(value,'value') 
    const HandleChange=(selected,name)=>{
        // console.log(selected)
        // setValue((state)=>({
        //     ...state,[name]:selected.label
        // }))
        setValue(selected)
        selectFunction(selected,index)
        // if(origen==='mapa'){
        //     switch(selected.filter){
        //         case 'Municipio': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:selected.value,dispId:props.ubicacion.dispId,templateId:props.ubicacion.templateId})
        //                             break;
        //         case 'Tecnología': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:selected.value,templateId:props.ubicacion.templateId})
        //                             break; 
        //         case 'Métrica': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId:selected.value})
        //                             break;                    
        //         default:
        //                 break;                        
        //     }
        // }else if(origen==='admin'){
        //         //console.log("admin",selected.value)
        // }
        
        
    }
    // const targetElement = document.getElementById('content-menu-search');
    return(
        <div className='menuSearchOptionGS' style={{padding:'unset'}}>
            <div className={origen==='mapa'?'compactSelector':'compactSelectorAdminGS'}>
                {/* <label htmlFor='selector' className={origen==='mapa'?'labelSelector':'labelSelectorAdmin'}>{titulo}:</label> */}
                {
                    
                        origen==='mapa'?
                            <Select
                            options={options}
                            value={(value.length===0)?options[opcion_default]:value}
                            // options={{filter:titulo, value: 0, label: 'cargando...' }}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            onChange={(selected)=>HandleChange(selected,titulo)}
                            // placeholder={loading?'cargando..':placeholder}
                            // placeholder={'hola'}
                            noOptionsMessage={() => "No existe"}
                            isDisabled={loading}
                        />
                        :
                        (origen==='bottom')?<Select
                        options={options}
                        styles={customStyles}
                        // menuPortalTarget={targetElement}
                        // options={{filter:titulo, value: 0, label: 'cargando...' }}
                        value={(value.length===0)?options[opcion_default]:value}
                        className="react-select-container-admin-gs"
                        classNamePrefix="react-select-admin-gs"
                        onChange={(selected)=>HandleChange(selected,titulo)}
                        placeholder={(placeholder=="" || placeholder==undefined)?(loading?'cargando..':titulo):placeholder}
                        // placeholder="hola"
                        noOptionsMessage={() => capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                        isDisabled={loading}
                        menuPlacement="top" 
                    />:<Select
                    options={options}
                    styles={customStyles}
                    // menuPortalTarget={targetElement}
                    // options={{filter:titulo, value: 0, label: 'cargando...' }}
                    value={(value.length===0)?options[opcion_default]:value}
                    className="react-select-container-admin-gs"
                    classNamePrefix="react-select-admin-gs"
                    onChange={(selected)=>HandleChange(selected,titulo)}
                    placeholder={(placeholder=="" || placeholder==undefined)?(loading?'cargando..':titulo):placeholder}
                    // placeholder="hola"
                    noOptionsMessage={() => capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                    isDisabled={loading}
                />
                        
                }
                
                
            </div>
        </div>
    )
}

export default SelectorAdmin